import { Heading } from "@/components/ui/heading"
import * as Progress from "@/components/ui/progress"
import { Text } from "@/components/ui/text"
import { createEffect } from "solid-js"
import { Flex, Grid } from "styled-system/jsx"

interface QuizProgressProps {
  currentIndex: number
  totalQuestions: number
}

export default function (props: QuizProgressProps) {

  createEffect(() => {
    console.log(props.currentIndex)
  })

  return (
    <Grid px='3' gridTemplateColumns='auto 1fr' alignItems='center'>
      <Heading textStyle='label'>{props.currentIndex + 1} of {props.totalQuestions}</Heading>
      <Progress.Root colorPalette='jade' max={props.totalQuestions} value={props.currentIndex + 1}>
        <Progress.Track>
          <Progress.Range>
          </Progress.Range>
        </Progress.Track>
      </Progress.Root>
    </Grid>
  )
}
